import { useState, useRef, useEffect } from 'react'
import { MoreHorizontal, Edit, Trash2, Clock } from 'lucide-react'

interface ActionsMenuProps {
  onEdit: () => void
  onDelete: () => void
  onLogTime?: () => void
}

export function IssueActionsMenu({ onEdit, onDelete, onLogTime }: ActionsMenuProps) {
  const [isOpen, setIsOpen] = useState(false)
  const menuRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setIsOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  return (
    <div className="relative" ref={menuRef}>
      <button
        onClick={(e) => {
          e.stopPropagation()
          setIsOpen(!isOpen)
        }}
        className="rounded-md p-1.5 text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 hover:text-slate-600 dark:hover:text-slate-300 transition-colors cursor-pointer"
      >
        <MoreHorizontal className="h-4 w-4" />
      </button>

      {isOpen && (
        <div className="absolute right-0 top-full mt-1 z-50 w-56 rounded-lg border border-slate-200 bg-white shadow-lg dark:border-slate-800 dark:bg-slate-900 py-1 animate-in fade-in">
          <button
            onClick={(e) => {
              e.stopPropagation()
              onEdit()
              setIsOpen(false)
            }}
            className="w-full flex items-center gap-2 px-3 py-2 text-xs font-medium text-slate-700 hover:bg-slate-50 dark:text-slate-200 dark:hover:bg-slate-800 cursor-pointer transition-colors"
          >
            <Edit className="h-3.5 w-3.5" />
            Edit issue
          </button>

          {onLogTime && (
            <>
              <div className="border-t border-slate-100 dark:border-slate-800 my-1" />
              <button
                onClick={(e) => {
                  e.stopPropagation()
                  onLogTime()
                  setIsOpen(false)
                }}
                className="w-full flex items-center gap-2 px-3 py-2 text-xs font-medium text-slate-700 hover:bg-slate-50 dark:text-slate-200 dark:hover:bg-slate-800 cursor-pointer transition-colors"
              >
                <Clock className="h-3.5 w-3.5" />
                Log time
              </button>
            </>
          )}

          <div className="border-t border-slate-100 dark:border-slate-800 my-1" />

          <button
            onClick={(e) => {
              e.stopPropagation()
              onDelete()
              setIsOpen(false)
            }}
            className="w-full flex items-center gap-2 px-3 py-2 text-xs font-medium text-red-600 hover:bg-red-50 dark:hover:bg-red-950/20 cursor-pointer transition-colors"
          >
            <Trash2 className="h-3.5 w-3.5" />
            Delete issue
          </button>
        </div>
      )}
    </div>
  )
}
